<div class="control-item">
    @if (showReleaseFolderButton) {
        <kno2-button
            kno2Tooltip="Open Release Folder Location"
            severity="primary"
            size="small"
            (click)="showFolderClick()">
            <i class="pi pi-folder"></i>
            Show Release Folder
        </kno2-button>
    }
</div>
